import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { routes } from './routes'

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, _, next) => {
  const auth = useAuthStore()

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return next({ name: 'login' })
  } else if (to.meta.requiredClaim && !auth.hasClaim(to.meta.requiredClaim)) {
    return next({ name: 'dashboard' })
  } else if (to.name === 'login' && auth.isAuthenticated) {
    return next({ name: 'dashboard' })
  }

  next()
})

export default router
